import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { Autoplay } from "swiper/modules";

const MoSlider = () => {
  return (
    <div className="hideindesktop">
      <Swiper
        slidesPerView={1.1}
        spaceBetween={10}
        loop={true}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        breakpoints={{
          768: { slidesPerView: 2 },
          992: { slidesPerView: 3 },
        }}
        modules={[Autoplay]}
      >
        {[
          { img: "Us-icon9.svg", text: "Affordable Pricing" },
          { img: "Us-icon10.svg", text: "Global Clientele" },
          { img: "Us-icon11.svg", text: "Proven Track Record" },
          { img: "Us-icon9.svg", text: "Cutting-Edge Technology" },
          { img: "Us-icon10.svg", text: "24 / 7 Support" },
        ].map((item, index) => (
          <SwiperSlide key={index}>
            <div className="text-center p-5 " style={{ borderRadius: "10px", backgroundColor: "rgba(255, 255, 255, 1)",height:'250px' }}>
              <img src={`https://d3vqz9qyn2r1xe.cloudfront.net/imges/${item.img}`} alt="" />
              <p className="fw-700 fs-20 plus pt-4" style={{ color: "rgba(0, 0, 0, 1)" }}>{item.text}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default MoSlider;
